import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NgbDateStruct, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NewModalService } from 'app/generic/new-modal/new-modal.service';
import * as L from 'leaflet';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { DatiService } from './dati.service';
import { HookFunctions } from 'app/generic/hookFunctions';
import { ActivatedRoute, Router } from '@angular/router';
import { MultiButtonRendererComponent } from 'app/generic/multi-button-renderer/multi-button-renderer.component';
import { ColDef } from 'ag-grid-community';
import { TokenGenerator } from 'app/shared/token-generator';
import { HttpHeaders } from '@angular/common/http';

@Component({
  selector: 'app-dati',
  templateUrl: './dati.component.html',
  styleUrls: ['./dati.component.scss'],
  providers: [DatiService, NgbModal, NewModalService, HookFunctions]
})
export class DatiComponent implements OnInit, AfterViewInit, OnDestroy {
  get headers(): HttpHeaders {
  return new HttpHeaders({
    'Content-Type': 'application/json',
    'X-Custom-Token': TokenGenerator.generateToken()
  });
}

  sensorMetaById: { [typeId: number]: { key: string, title: string, unit: string } } = {
  1: { key: 'barometri', title: 'Pressioni Barometriche rilevate (hPa)', unit: '(hPa)' },
  2: { key: 'ventoscalare', title: 'Metri al secondo rilevati (m/s)', unit: '(m/s)' },
  3: { key: 'ventoraffica', title: 'Metri al secondo rilevati (m/s)', unit: '(m/s)' },
  12: { key: 'idrometri', title: 'Dati rilevati rispetto allo "0" idrometrico', unit: '(m)' },
  13: { key: 'igrometri', title: 'Percentuali rilevate (%)', unit: '(%)' },
  24: { key: 'pluviometri', title: 'Istogramma cumulata oraria', unit: '(mm)' },
  25: { key: 'radiometri', title: 'Irradiazioni rilevate (W/m²)', unit: '(W/m²)' },
  31: { key: 'termometri', title: 'Temperatura oraria rilevata', unit: '(°C)' }
};

  sensorTypeMap: { [key: string]: number } = {
    barometri: 1,
    ventoscalare: 2,
    ventoraffica: 3,
    idrometri: 12,
    igrometri: 13,
    pluviometri: 24,
    radiometri: 25,
    termometri: 31
  };

  getFriendlyName(sensorKey: string): string {
    const normalizedKey = sensorKey?.toLowerCase().replace(/\s+/g, '');
    const friendlyMapping: { [key: string]: string } = {
      'barometri': 'Barometro',
      'barometro': 'Barometro',
      'ventoscalare': 'Velocità del Vento Media',
      'velocitaventomedia': 'Velocità del Vento Media',
      'ventoraffica': 'Velocità del Vento di Raffica',
      'velocitaventoraffica': 'Velocità del Vento di Raffica',
      'idrometri': 'Idrometro',
      'idrometro': 'Idrometro',
      'igrometri': 'Igrometro',
      'igrometro': 'Igrometro',
      'pluviometri': 'Pluviometro Puntuale',
      'pluviometro': 'Pluviometro Puntuale',
      'pluviometropuntuale': 'Pluviometro Puntuale',
      'radiometri': 'Radiometro',
      'radiometro': 'Radiometro',
      'termometri': 'Termometro',
      'termometro': 'Termometro'
    };

    return friendlyMapping[normalizedKey] || sensorKey;
  }
  getKeyFromSensorType(tipoSensore: string): string {
    // Mappa le descrizioni dei sensori alle chiavi utilizzate in getFriendlyName
    const typeMapping: { [key: string]: string } = {
      'Barometro': 'barometri',
      'Velocità del Vento Media': 'ventoscalare',
      'Velocità del Vento di Raffica': 'ventoraffica',
      'Idrometro': 'idrometri',
      'Igrometro': 'igrometri',
      'Pluviometro Puntuale': 'pluviometri',
      'Radiometro': 'radiometri',
      'Termometro': 'termometri'
    };

    return typeMapping[tipoSensore] || tipoSensore.toLowerCase();
  }


  customLocaleText = {
    noRowsToShow: 'Nessun dato disponibile',
    loadingOoo: 'Caricamento in corso...',
    page: 'Pagina',
    of: 'di',
    more: 'Altro',
    to: 'a',
    contains: 'Contiene',
  };

  @ViewChild('theModalDetailDati', { static: false }) theModalDetailDati: ElementRef;
  @ViewChild('theModalSensori') theModalSensori: ElementRef;


  private mapDati: L.Map | undefined;
  private markersLayerDati: L.LayerGroup = new L.LayerGroup([]);

  stationList: any = []; // Lista di tutte le stazioni
  stationListSelect: any[] = [];
  sensorList: any = [];  // Lista dei sensori di una stazione
  selectedStationDetails: any = null;
  selectedStation: string = '';
  selectedSensorType: string = "all"; // Default: mostra tutte le stazioni
  idStazioneSelect: any = null;
  selectedSensorIdDetail: any;
  selectedSensorDetail: any;
  private stationMarkers = new Map<string, L.Marker>();

  columnDefs: any[];
  defaultColDef: any;

  dataFilterDa: Date;
  dataFilterA: Date;

  formFilter: FormGroup;

  tipoPersonaEstrazione;

  isTabella = false;
  gridOptions: any;
  gridOptionsSensori: any
  dataTabella = [];
  sensoriToDettaglioTabella: any;
  stazioneSelezionata: any;

  private customIcon = L.icon({
    iconUrl: './assets/img/spotlight-poi2-small.png',
    iconSize: [32, 32],
    iconAnchor: [16, 16],
    popupAnchor: [0, -35]
  });
  private selectedIcon = L.icon({
    iconUrl: './assets/img/spotlight-poi2-selected.png',
    iconSize: [32, 32],
    iconAnchor: [16, 16],
    popupAnchor: [0, -35]
  });

  private initialMapCenter: L.LatLngExpression = [40.7556, 14.9112];
  private initialMapZoom: number = 9;
  //estrazione
  dataForm: FormGroup;
  estrazioneSubForm: FormGroup;
  today: NgbDateStruct;
  // Massima data selezionabile (ieri)
  maxSelectableDate: NgbDateStruct;
  maxToDate: NgbDateStruct | null = null;
  dateConsultazione = {
    from: null,
    to: null
  }
  datiConsultazioneGiorn: any = null;
  gridOptionsConsultazione: any;
  rowData: any;


  dataTypes = [
    { value: 'csv', label: 'CSV' },
    { value: 'json', label: 'JSON' },
    { value: 'xml', label: 'XML' }
  ];
  sensoreToDownload: any;
  allStations: any[];
  tipoVisualizzazione: number = 1;
  finalMaxDate: NgbDateStruct;
  finalMaxDateSub: NgbDateStruct | null = null;
  finalMaxDateGiornalieri: NgbDateStruct | null = null;

  pdfDocumentUrl = '/assets/docs/sistema_monitoraggio_idrometeoclima_e_ondamare.pdf';
  
  // URL per il file Excel
  excelDocumentUrl = '/assets/docs/TABELLA_STAZIONI.xlsx';

  // Proprietà per gestire la disabilitazione temporanea dei pulsanti
  isButtonDisabled = false;
  buttonDisableTimeout = 10000; // 10 secondi di disabilitazione
  private buttonDisableTimer: any;

  // Proprietà per gestire lo stato di caricamento delle richieste
  isLoadingConsultaDati = false;
  isLoadingEstraiDati = false;
  isLoadingEstraiDatiSub = false;

  // Proprietà per gestire la consultazione intelligente
  private lastConsultaParams: { from: any, to: any, idSensore: string } | null = null;
  isConsultaDisabled = false;

  constructor(
    private fb: FormBuilder,
    private modalService: NgbModal,
    private newModal: NewModalService,
    public restService: DatiService,
    public hf: HookFunctions,
    private route: ActivatedRoute,
    private router: Router
  ) {
    const now = new Date();
    this.today = {
      year: now.getFullYear(),
      month: now.getMonth() + 1,
      day: now.getDate()
    };
    // Calcola ieri come limite massimo selezionabile
    const yesterday = new Date(now);
    yesterday.setDate(now.getDate() - 1);
    this.maxSelectableDate = {
      year: yesterday.getFullYear(),
      month: yesterday.getMonth() + 1,
      day: yesterday.getDate()
    };

    this.sensorList = [];
    this.columnDefs = [
      { headerName: 'ID Stazione', field: 'idStazione', sortable: true, filter: true },
      { headerName: 'Denominazione', field: 'denominazione', sortable: true, filter: true },
      { headerName: 'Comune', field: 'comune', sortable: true, filter: true },
      { headerName: 'Provincia', field: 'provincia', sortable: true, filter: true },
      { headerName: 'Bacino', field: 'bacino', sortable: true, filter: true },
      { headerName: 'Quota (m)', field: 'quota', sortable: true, filter: true },
      { headerName: 'Latitudine', field: 'latitudine', sortable: true, filter: true },
      { headerName: 'Longitudine', field: 'longitudine', sortable: true, filter: true }
    ];

    this.defaultColDef = {
      flex: 1,
      minWidth: 100,
      resizable: true
    };

  }

  ngOnInit(): void {
    this.destroyMap();
    // this.setupFormSearch();
    this.initMap();
    this.setupFormGiornalieri()
    this.setupFormSubGiornalieri()
  }

  ngAfterViewInit(): void {
    this.loadStations();
    this.setupAgSettings();
    this.caricaStazioniTabella();
    this.setupAgSettingsSensori();
    this.isTabella = true;
  }

  ngOnDestroy(): void {
    this.destroyMap();
    this.clearButtonDisableTimer();
  }

  routeTo(path: any) {
    this.closeAllModal()
    this.router.navigate([path]);
  }

  setupFormGiornalieri() {
    this.dataForm = this.fb.group({
      tipoEstrazione: ['1'],
      //giornalieri
      
      dataDaGiornalieri: [null, Validators.required],
      dataAGiornalieri: [null, Validators.required],
      //anagrafica
      
      nome: [''],
      cognome: [''],
      email: ['', [Validators.email, Validators.required]],
      termsAccepted: [false],
    });
  }

  setupFormSubGiornalieri() {
    this.estrazioneSubForm = this.fb.group({
      tipoEstrazione: ['0'],
      //subgiornalieri
      dataDaSub: [null, Validators.required],
      dataASub: [null, Validators.required],
      tipoEnteEstrazione: ["", Validators.required],
      altroEnte: [''],
      motivazioneEstrazione: ["", Validators.required],
      altraMotivazione: [''],
      //anagrafica
      nome: [''],
      cognome: [''],
      email: ['', [Validators.email, Validators.required]],
      termsAccepted: [false],
    });
  }



  infoSection() {
    const text = `
      L’utente, dopo aver selezionato il sensore presso la stazione di interesse, deve specificare l’intervallo temporale,
      indicando la data di inizio e di fine, che non potrà essere di ampiezza superiore ad 1 anno.
      Completata la selezione, l’utente deve indicare l’indirizzo e-mail presso il quale desidera ricevere i dati.
      Dopo aver risolto il test di sicurezza reCAPTCHA, l’utente può convalidare la richiesta premendo il tasto “Invia Dati”.
      I dati saranno trasmessi come allegato, in formato csv, mediante posta elettronica certificata della Regione all’indirizzo e-mail specificato.
      I dati trasmessi sono riferiti all’ora solare (tempo UTC+1).
    `;
    this.newModal.open("Estrarre informazioni", text, "bg-info");
  };

  openModal(modal) {
    this.modalService.open(modal, { backdrop: 'static', windowClass: "modalDettaglio" }).result.then(
      () => document.body.classList.remove('modal-open'),
      () => document.body.classList.remove('modal-open')
    );
  };

  openSensorDownload(sensore) {
    this.tipoVisualizzazione = 1;
    this.setupFormGiornalieri();
    this.setupFormSubGiornalieri();
    this.sensoreToDownload = {};

    this.sensoreToDownload = sensore;
    this.modalService.open(this.theModalDetailDati, { backdrop: 'static', windowClass: "modalDettaglioDati" });
    this.setupAgConsultazione();
    // this.newModal.open("Attenzione recupero informazioni", "Non è stato possibile recuperare le informazioni richieste", "bg-danger");
  };

  closeSingleModal(modal) {
    modal.close('close');
  };

  closeAllModal() {
    let ref = this;
    ref.modalService.dismissAll();
  };

  private initMap(): void {
    if (this.mapDati) {
      this.destroyMap();
    };

    this.mapDati = L.map('mapDati', {
      center: this.initialMapCenter,
      //zoom: this.initialMapZoom,
      zoomSnap: 0.40,
      scrollWheelZoom: true
    });

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 18,
      attribution: 'Protezione Civile Regione Campania'
    }).addTo(this.mapDati);

    this.markersLayerDati.addTo(this.mapDati);
  };

  private destroyMap(): void {
    if (this.mapDati) {
      this.mapDati.remove();
    }
  };

  private parseCoordinate(coordinate: string): number {
    if (!coordinate) return NaN;
    // Sostituisci eventuali virgole con punti
    const normalized = coordinate.replace(',', '.');
    return parseFloat(normalized);
  };

  private loadStations(): void {
    this.restService.selectAllStazioniByFilters().then(res => {
      const stazioni = res.listaStazioni || [];

      // Ordina alfabeticamente per denominazione
      // const stazioniOrdinate = stazioni.sort((a: any, b: any) => {
      //   const denomA = a.denominazione || '';
      //   const denomB = b.denominazione || '';
      //   return denomA.localeCompare(denomB);
      // });

      // Mantiene l'ordine originale dal servizio REST
      this.stationList = stazioni;
      this.stationListSelect = stazioni;
      this.allStations = [...stazioni];
      this.renderMarkers();
    });
  }

  private renderMarkers(filteredStations: any[] = this.allStations, highlightId: string = ''): void {
    this.markersLayerDati.clearLayers();
    this.stationMarkers.clear();
    const bounds = new L.LatLngBounds([]);

    filteredStations.forEach(station => {
      const lat = this.parseCoordinate(station.latitudine);
      const lng = this.parseCoordinate(station.longitudine);
      if (!isNaN(lat) && !isNaN(lng)) {
        const icon = (station.idStazione === highlightId) ? this.selectedIcon : this.customIcon;
        const marker = L.marker([lat, lng], { icon })
        const tooltipContent = `
        <div style="text-align:center;">
          ${station.idSensore ? `<div>ID SENSORE: <span style="text-transform:uppercase"><strong>${station.idSensore}</strong></span></div>` : ''}
          ${station.comune ? `<div>COMUNE: <span class="uppercase"><strong>${station.comune.toUpperCase()} (${station.provincia.toUpperCase()})</strong></span></div>` : ''}
          ${station.denominazione ? `<div>NOME: <span class="uppercase"><strong>${station.denominazione.toUpperCase()}</strong></span></div>` : ''}
          ${station.quota && station.quota != "" ? `<div>QUOTA: <span class="uppercase"><strong>${station.quota} m.</strong></span></div>` : ''}
          ${station.bacino && station.bacino != "" && station.bacino !== null ? `<div>BACINO: <span class="uppercase"><strong> ${station.bacino} </strong></span></div>` : ''}
        </div>
      `;
        marker.bindTooltip(tooltipContent, {
          direction: 'top',
          offset: [0, -10],
          className: 'leaflet-tooltip'
        });

        marker.on('click', () => {
          this.onStationChange(station.idStazione, this.selectedSensorType === 'all' ? '*' : this.selectedSensorType);
        });
        this.stationMarkers.set(station.idStazione, marker);
        this.markersLayerDati.addLayer(marker);
        bounds.extend([lat, lng]);
      }
    });

    if (highlightId && this.stationMarkers.has(highlightId)) {
      const pos = this.stationMarkers.get(highlightId)?.getLatLng();
      if (pos) this.mapDati?.setView(pos);
    } else {
      const featureGroup = L.featureGroup(Array.from(this.stationMarkers.values()));
      this.mapDati?.fitBounds(featureGroup.getBounds(), { padding: L.point(24, 24) });
    }
  };

  public onStationChange(stationId: string, typeId: string): void {
    this.selectedStation = stationId;
    const tipoSensore = typeId !== '*' ? typeId : 'all';

    this.idStazioneSelect = stationId;

    this.evidenziaStazioneInTabella(stationId);

    if (!stationId) {
      this.sensorList = [];
      this.renderMarkers();
      return;
    }

    const fetcher = {
      all: () => this.restService.listAllSensoriByIdStazione(stationId, '*'),
      igrometri: () => this.restService.listAllSensoriByIdStazione(stationId, 13),
      termometri: () => this.restService.listAllSensoriByIdStazione(stationId, 31),
      pluviometri: () => this.restService.listAllSensoriByIdStazione(stationId, 24),
      ventoscalare: () => this.restService.listAllSensoriByIdStazione(stationId, 2),
      ventoraffica: () => this.restService.listAllSensoriByIdStazione(stationId, 3),
      barometri: () => this.restService.listAllSensoriByIdStazione(stationId, 1),
      idrometri: () => this.restService.listAllSensoriByIdStazione(stationId, 12),
      radiometri: () => this.restService.listAllSensoriByIdStazione(stationId, 25)
    }[tipoSensore];

    if (fetcher) {
      fetcher().then(data => {
        if (data) {
          // Ordina i sensori per nome
          // this.sensorList = (data || []).sort((a: any, b: any) => {
          //   const nomeA = a.nome || '';
          //   const nomeB = b.nome || '';
          //   return nomeA.localeCompare(nomeB);
          // });
          // Mantiene l'ordine originale dal servizio REST
          this.sensorList = data || [];
          this.renderMarkers(this.stationList, stationId);
        } else {
          this.sensorList = [];
        }
      });
    }
  }


  public onSensorTypeFilterChange(): void {
    this.resetSelezioneTabella(); 
    this.idStazioneSelect = null;
    if (this.selectedSensorType === 'all') {
      this.sensorList = [];
      this.renderMarkers();
      // this.dataTabella = [...this.allStations].sort((a: any, b: any) => {
      //   const denomA = a.denominazione || '';
      //   const denomB = b.denominazione || '';
      //   return denomA.localeCompare(denomB);
      // });
      // Mantiene l'ordine originale dal servizio REST
      this.dataTabella = [...this.allStations];
      return;
    }
    this.sensorList = [];

    const sensorFetchers: { [key: string]: () => Promise<any> } = {
      igrometri: () => this.restService.selectAllStazioniByIdTypo(this.sensorTypeMap.igrometri),
      termometri: () => this.restService.selectAllStazioniByIdTypo(this.sensorTypeMap.termometri),
      pluviometri: () => this.restService.selectAllStazioniByIdTypo(this.sensorTypeMap.pluviometri),
      ventoscalare: () => this.restService.selectAllStazioniByIdTypo(this.sensorTypeMap.ventoscalare),
      ventoraffica: () => this.restService.selectAllStazioniByIdTypo(this.sensorTypeMap.ventoraffica),
      barometri: () => this.restService.selectAllStazioniByIdTypo(this.sensorTypeMap.barometri),
      idrometri: () => this.restService.selectAllStazioniByIdTypo(this.sensorTypeMap.idrometri),
      radiometri: () => this.restService.selectAllStazioniByIdTypo(this.sensorTypeMap.radiometri)
    };

    const fetchSensors = sensorFetchers[this.selectedSensorType];
    if (fetchSensors) {
      fetchSensors()
        .then((data) => {
          if (data && data.listaStazioni) {
            // Ordina le stazioni per denominazione
            // const stazioniOrdinate = data.listaStazioni.sort((a: any, b: any) => {
            //   const denomA = a.denominazione || '';
            //   const denomB = b.denominazione || '';
            //   return denomA.localeCompare(denomB);
            // });

            // Mantiene l'ordine originale dal servizio REST
            this.stationList = data.listaStazioni;
            this.stationListSelect = data.listaStazioni;

            this.dataTabella = [...data.listaStazioni];

            this.renderMarkers(this.stationList);
          } else {
            this.sensorList = [];
            this.dataTabella = [];
            this.markersLayerDati.clearLayers();
          }
        })
        .catch((err) => {
          this.dataTabella = [];
        });
    }
  }

  public showAllMarkers(): void {
    this.sensorList = [];
    this.selectedSensorType = "all";
    this.loadStations();

    this.resetSelezioneTabella();

    // this.dataTabella = [...this.allStations].sort((a: any, b: any) => {
    //   const denomA = a.denominazione || '';
    //   const denomB = b.denominazione || '';
    //   return denomA.localeCompare(denomB);
    // });
    // Mantiene l'ordine originale dal servizio REST
    this.dataTabella = [...this.allStations];
  }

  private evidenziaStazioneInTabella(stationId: string): void {

    setTimeout(() => {
      if (this.gridOptions?.api) {

        let found = false;
        this.gridOptions.api.forEachNode((node: any) => {
          if (node.data && node.data.idStazione === stationId) {
            node.setSelected(true);
            // Scorri alla riga
            this.gridOptions.api.ensureIndexVisible(node.rowIndex, 'middle');
            found = true;
          } else {
            node.setSelected(false);
          }
        });

        if (!found) {
          }
      } else {
        
      }
    }, 200); // Aumenta il delay se necessario
  }

  private resetSelezioneTabella(): void {
    if (this.gridOptions?.api) {
      this.gridOptions.api.deselectAll();
    }
    this.idStazioneSelect = null;
  }

  closeSensorList() {
    this.sensorList = [];
  }

  public onStationFilterChange(): void {
    const stationId = this.idStazioneSelect;

    if (!stationId) {
      this.resetSelezioneTabella();
      return;
    }

    this.onStationChange(stationId, this.selectedSensorType === 'all' ? '*' : this.selectedSensorType);
  }

  setupAgConsultazione() {
    this.gridOptionsConsultazione = {
      animateRows: true,
      pagination: true,
      paginationPageSize: this.currentPageSizeConsultazione,
      paginationPageSizeSelector: this.pageSizeOptionsConsultazione,
      paginationAutoPageSize: false,
      suppressPaginationPanel: false,
      
      onPaginationChanged: (event: any) => {
        const newPageSize = event.api.paginationGetPageSize();
        if (newPageSize !== this.currentPageSizeConsultazione) {
          this.currentPageSizeConsultazione = newPageSize;
        }
      },
      
      enableCellTextSelection: false,
      rowHeight: 50,
      suppressMovableColumns: true,
      suppressFilterPanel: false,
      defaultColDef: {
        editable: false,
        filter: true,
        floatingFilter: false,
        sortable: true,
        flex: 1,
        minWidth: 100,
        cellStyle: {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        },
        cellClass: 'wrap-text',
        filterParams: {
          filterOptions: ['contains'],
          suppressAndOrCondition: true,
          floatingFilter: false,
          sortable: true,
        },
      },
      rowStyle: {
        background: '#fff',
        color: '#000',
      },
      columnDefs: [],
    };
  }



  consultaDati() {
  // Controlla se è già in corso un caricamento
  if (this.isLoadingConsultaDati) {
    return;
  }

  // Controlla se è disabilitato per parametri identici
  const currentParams = {
    from: this.dateConsultazione.from,
    to: this.dateConsultazione.to,
    idSensore: this.sensoreToDownload.idSensore
  };

  if (this.isConsultaDisabled && this.lastConsultaParams && 
      this.areParamsEqual(currentParams, this.lastConsultaParams)) {
    return;
  }

  const request = {
    from: this.fromObjectToMillisec(this.dateConsultazione.from),
    to: this.fromObjectToMillisec(this.dateConsultazione.to),
    interval: "10",
    elab: "RainIntervals",
    mail: null,
    idSensore: this.sensoreToDownload.idSensore,
    stato: 0,
    exportType: 1,
    nome: null,
    cognome: null,
    ente: null,
    nomeSensore: this.sensoreToDownload.nome.replace(/\s/g, ''),
    idTipoSensore: this.sensoreToDownload.idTipoSensore,
    nomeTipoSensore: this.sensoreToDownload.tipoSensore,
  };

  // validazione
  if (!this.dateConsultazione.from || !this.dateConsultazione.to) {
    this.newModal.open(
      "Attenzione",
      "Bisogna necessariamente selezionare una data di inizio e una data di fine.",
      "bg-warning"
    );
    return;
  }

  if (this.dateConsultazione.from > this.dateConsultazione.to) {
    this.newModal.open(
      "Attenzione",
      "La data di inizio periodo non può essere superiore a quella di fine periodo.",
      "bg-warning"
    );
    return;
  }

  // Avvia il caricamento e disabilita il pulsante per questi parametri
  this.isLoadingConsultaDati = true;
  this.isConsultaDisabled = true;
  this.lastConsultaParams = { ...currentParams };

  // richiesta
  this.restService
    .richiediDatiConsultazione(request, this.headers)
    .then((data: any) => {
      this.isLoadingConsultaDati = false; // Ferma il caricamento
      
      if (data && data.dailyStats && Array.isArray(data.dailyStats) && data.dailyStats.length > 1) {
        const headers = data.dailyStats[0];
        const rows = data.dailyStats.slice(1);

        const columnDefs = this.getDynamicColumnDefs(headers);

        const rowData = rows.map((row: string[]) =>
          headers.reduce((acc, header, i) => {
            acc[header] = row[i];
            return acc;
          }, {} as any)
        );

        this.gridOptionsConsultazione.api?.setColumnDefs(columnDefs);
        this.gridOptionsConsultazione.api?.setRowData(rowData);

        this.gridOptionsConsultazione.columnDefs = columnDefs;
        this.datiConsultazioneGiorn = rowData;

        console.log("Colonne dinamiche:", columnDefs);
        console.log("Righe tabella:", rowData);
      } else {
        this.newModal.open(
          "Attenzione",
          "Non è stato possibile evadere la richiesta, riprovare più tardi",
          "bg-danger"
        );
      }
    })
    .catch((err) => {
      this.isLoadingConsultaDati = false; // Ferma il caricamento anche in caso di errore
      console.warn(err);
      this.newModal.open(
        "Attenzione",
        "Non è stato possibile evadere la richiesta, riprovare più tardi",
        "bg-danger"
      );
    });
}

  getDynamicColumnDefs(headers: string[]): ColDef[] {
    return headers.map(header => ({
      headerName: header,
      field: header,
      filter: header.includes("Data") ? "agDateColumnFilter" : "agTextColumnFilter",
      floatingFilter: false,
      valueFormatter: (params: any) => params.value || "-",
      // Configurazione specifica per i filtri di data
      ...(header.includes("Data") && {
        filterParams: {
          comparator: (filterLocalDateAtMidnight: Date, cellValue: string) => {
            if (!cellValue) return 0;
            
            // Converte il formato dd-mm-yyyy in Date
            const dateParts = cellValue.split('-');
            if (dateParts.length === 3) {
              const day = parseInt(dateParts[0], 10);
              const month = parseInt(dateParts[1], 10) - 1; // I mesi in JavaScript sono 0-based
              const year = parseInt(dateParts[2], 10);
              const cellDate = new Date(year, month, day);
              
              if (cellDate < filterLocalDateAtMidnight) return -1;
              if (cellDate > filterLocalDateAtMidnight) return 1;
              return 0;
            }
            return 0;
          },
          // Formato di input per il date picker
          browserDatePicker: true,
          // Messaggi localizzati
          filterOptions: ['equals', 'greaterThan', 'lessThan', 'inRange'],
          suppressAndOrCondition: true
        }
      }),
      // Configurazione per colonne di testo
      ...(!header.includes("Data") && {
        filterParams: {
          filterOptions: ['contains', 'equals', 'startsWith', 'endsWith'],
          suppressAndOrCondition: true
        }
      })
    }));
  }



  estraiDaConsultazione() {
    //inserire update dati da datepicker consultazione -> form estrazione
    this.updateNavigation(3);
  }

  //Estrazione 

  updateNavigation(sezione) {
    this.setupFormGiornalieri();
    this.setupFormSubGiornalieri();
    this.dateConsultazione = {
      from: null,
      to: null
    }
    this.datiConsultazioneGiorn = null;
    this.tipoVisualizzazione = sezione;
  }

  estraiDati() {
    // Controlla se i pulsanti sono disabilitati
    if (!this.canExecuteRequest()) {
      return;
    }

    let request = {
      "from": this.fromObjectToMillisec(this.dataForm.get('dataDaGiornalieri')?.value),
      "to": this.fromObjectToMillisec(this.dataForm.get('dataAGiornalieri')?.value),
      "interval": "10",
      "elab": "RainIntervals",
      "mail": this.dataForm.get('email').value,
      "idSensore": this.sensoreToDownload.idSensore,
      "stato": 0,
      "exportType": 1, // 1 se giornalieri, 0 se subgiornalieri
      "nome": this.dataForm.get('nome').value,
      "cognome": this.dataForm.get('cognome').value,
      "nomeSensore": this.sensoreToDownload.nome.replace(/\s/g, ''),
      "idTipoSensore": this.sensoreToDownload.idTipoSensore,
      "nomeTipoSensore": this.sensoreToDownload.tipoSensore,
    };

    if (this.hf.validateFormByFormGroupAndFormId(this.dataForm, "dataForm", true)) {
      if (this.fromObjectToMillisec(this.dataForm.get('dataDaGiornalieri')?.value) > this.fromObjectToMillisec(this.dataForm.get('dataAGiornalieri')?.value)) {
        this.newModal.open("Attenzione", "la data di inizio periodo non può essere maggiore della data di fine periodo", "bg-danger");
        document.querySelector(`input[formControlName='dataDaGiornalieri']`).classList.add("border-danger")
        document.querySelector(`input[formControlName='dataAGiornalieri']`).classList.add("border-danger")
      } else if (this.checkTerms(2)) {
        // Avvia il caricamento e disabilita i pulsanti
        this.isLoadingEstraiDati = true;
        this.disableButtons();
        
        this.restService
          .richiediDati(request,this.headers)
          .then((data: any) => {
            this.isLoadingEstraiDati = false; // Ferma il caricamento
            if (data && data != null) {
              this.closeAllModal();
              this.newModal.open("Conferma", "La richiesta è stata presa in carico", "bg-success");
              this.sensoreToDownload = {};
              this.showAllMarkers();
            } else {
              this.newModal.open("Attenzione", "Non è stato possibile evadere la richiesta, riprovare più tardi", "bg-danger");
            }
          })
          .catch((err) => {
            this.isLoadingEstraiDati = false; // Ferma il caricamento anche in caso di errore
            console.warn(err);
            this.newModal.open("Attenzione", "Non è stato possibile evadere la richiesta, riprovare più tardi", "bg-danger");
          });
      }
    } else {
      console.warn("info mancanti")
    }
  };

  estraiDatiSubgiornalieri() {
    // Controlla se i pulsanti sono disabilitati
    if (!this.canExecuteRequest()) {
      return;
    }

    let request = {
      "from": this.fromObjectToMillisec(this.estrazioneSubForm.get('dataDaSub')?.value),
      "to": this.fromObjectToMillisec(this.estrazioneSubForm.get('dataASub')?.value),
      "interval": "10",
      "elab": "RainIntervals",
      "mail": this.estrazioneSubForm.get('email').value,
      "idSensore": this.sensoreToDownload.idSensore,
      "stato": 0,
      "exportType": 0, // 1 se giornalieri, 0 se subgiornalieri
      "nome": this.estrazioneSubForm.get('nome').value,
      "cognome": this.estrazioneSubForm.get('cognome').value,
      "ente": this.estrazioneSubForm.get('tipoEnteEstrazione').value,
      "enteAlt": this.estrazioneSubForm.get('tipoEnteEstrazione').value == 'Altro' ? this.estrazioneSubForm.get('altroEnte').value : "",
      "motivazione": this.estrazioneSubForm.get('motivazioneEstrazione').value,
      "motivazioneAlt": this.estrazioneSubForm.get('motivazioneEstrazione').value == 'Altro' ? this.estrazioneSubForm.get('altraMotivazione').value : "",
      "nomeSensore": this.sensoreToDownload.nome.replace(/\s/g, ''),
      "idTipoSensore": this.sensoreToDownload.idTipoSensore,
      "nomeTipoSensore": this.sensoreToDownload.tipoSensore,
    };

    if (this.estrazioneSubForm.get('tipoEnteEstrazione').value == 'Altro') {
      this.estrazioneSubForm.get('altroEnte').setValidators([Validators.required]);
    } else {
      this.estrazioneSubForm.get('altroEnte').clearValidators();
    }
    this.estrazioneSubForm.get('altroEnte').updateValueAndValidity();

    if (this.estrazioneSubForm.get('motivazioneEstrazione').value == 'Altro') {
      this.estrazioneSubForm.get('altraMotivazione').setValidators([Validators.required]);
    } else {
      this.estrazioneSubForm.get('altraMotivazione').clearValidators();
    }
    this.estrazioneSubForm.get('altraMotivazione').updateValueAndValidity();

    if (this.hf.validateFormByFormGroupAndFormId(this.estrazioneSubForm, "estrazioneSubForm", true)) {
      if (this.fromObjectToMillisec(this.estrazioneSubForm.get('dataDaSub')?.value) > this.fromObjectToMillisec(this.estrazioneSubForm.get('dataASub')?.value)) {
        this.newModal.open("Attenzione", "la data di inizio periodo non può essere maggiore della data di fine periodo", "bg-danger");
        document.querySelector(`input[formControlName='dataDaSub']`).classList.add("border-danger")
        document.querySelector(`input[formControlName='dataASub']`).classList.add("border-danger")
      } else if (this.checkTerms(1)) {
        // Avvia il caricamento e disabilita i pulsanti
        this.isLoadingEstraiDatiSub = true;
        this.disableButtons();
        
        this.restService
          .richiediDati(request,this.headers)
          .then((data: any) => {
            this.isLoadingEstraiDatiSub = false; // Ferma il caricamento
            if (data && data != null) {
              this.closeAllModal();
              this.newModal.open("Conferma", "La richiesta è stata presa in carico", "bg-success");
              this.sensoreToDownload = {};
              this.showAllMarkers();
            } else {
              this.newModal.open("Attenzione", "Non è stato possibile evadere la richiesta, riprovare più tardi", "bg-danger");
            }
          })
          .catch((err) => {
            this.isLoadingEstraiDatiSub = false; // Ferma il caricamento anche in caso di errore
            console.warn(err);
            this.newModal.open("Attenzione", "Non è stato possibile evadere la richiesta, riprovare più tardi", "bg-danger");
          });
      }
    }
  }

  checkTerms(formTemp) {
    if (formTemp == 2) {
      // console.log('giornform',this.dataForm.get('termsAccepted').value);
      if (this.dataForm.get('termsAccepted').value == true) {
        document.querySelector(`input[formControlName='termsAccepted']`).classList.remove("border-danger")
        return true
      } else if (this.dataForm.get('termsAccepted').value == false) {
        this.newModal.open("Attenzione", "Non è possibile effettuare un'estrazione senza aver accettato i termini e condizioni", "bg-danger");
        document.querySelector(`input[formControlName='termsAccepted']`).classList.add("border-danger")
        return false
      }
    } else if (formTemp == 1) {
      // console.log('subform',this.estrazioneSubForm.get('termsAccepted').value);

      if (this.estrazioneSubForm.get('termsAccepted').value == true) {
        document.querySelector(`input[formControlName='termsAccepted']`).classList.remove("border-danger")
        return true
      } else if (this.estrazioneSubForm.get('termsAccepted').value == false) {
        this.newModal.open("Attenzione", "Non è possibile effettuare un'estrazione senza aver accettato i termini e condizioni", "bg-danger");
        document.querySelector(`input[formControlName='termsAccepted']`).classList.add("border-danger")
        return false
      }
    } else {
      this.newModal.open("Attenzione", "Al momento non è possibile eseguire la richiesta, riprovare più tardi.", "bg-danger")
      return false
    }

  };


  fromObjectToMillisec(obj) {
    if (
      !obj ||
      typeof obj !== 'object' ||
      typeof obj.year !== 'number' ||
      typeof obj.month !== 'number' ||
      typeof obj.day !== 'number'
    ) {
      return "-";
    }

    const date = new Date(obj.year, obj.month - 1, obj.day);

    // Verifica se la data è valida
    if (isNaN(date.getTime())) {
      return "-";
    }

    return date.getTime();
  };

  onFromDateChange() {
    // Riabilita il pulsante consulta quando cambia la data di inizio
    this.resetConsultaState();

    if (this.dateConsultazione.from) {
      const fromDate = this.dateConsultazione.from;

      // Calcolo max date (from + 1 anno)
      this.maxToDate = {
        year: fromDate.year + 1,
        month: fromDate.month,
        day: fromDate.day
      };

      // Calcolo la vera max date (entro 1 anno e NON oltre oggi)
      this.finalMaxDate = this.compareDates(this.maxToDate, this.maxSelectableDate) > 0
        ? this.maxSelectableDate
        : this.maxToDate;

      // Se "to" è fuori range, lo resettiamo
      if (this.dateConsultazione.to) {
        const to = this.dateConsultazione.to;
        if (
          this.compareDates(to, fromDate) < 0 ||
          this.compareDates(to, this.finalMaxDate) > 0
        ) {
          this.dateConsultazione.to = null;
        }
      }
    } else {
      this.maxToDate = null;
      this.finalMaxDate = null;
      this.dateConsultazione.to = null;
    }
  }


  compareDates(d1: NgbDateStruct, d2: NgbDateStruct): number {
    if (d1.year !== d2.year) return d1.year - d2.year;
    if (d1.month !== d2.month) return d1.month - d2.month;
    return d1.day - d2.day;
  }

  onDataDaSubChange(): void {
    const fromDate: NgbDateStruct = this.estrazioneSubForm.get('dataDaSub')?.value;

    if (fromDate) {
      const maxPossible = {
        year: fromDate.year + 1,
        month: fromDate.month,
        day: fromDate.day
      };

      this.finalMaxDateSub =
        this.compareDates(maxPossible, this.maxSelectableDate) > 0 ? this.maxSelectableDate : maxPossible;

      const toDate: NgbDateStruct = this.estrazioneSubForm.get('dataASub')?.value;

      if (toDate) {
        if (
          this.compareDates(toDate, fromDate) < 0 ||
          this.compareDates(toDate, this.finalMaxDateSub) > 0
        ) {
          this.estrazioneSubForm.get('dataASub')?.setValue(null);
        }
      }
    } else {
      this.finalMaxDateSub = null;
      this.estrazioneSubForm.get('dataASub')?.setValue(null);
    }
  }

  onDataDaGiornalieriChange(): void {
    const fromDate = this.dataForm.get('dataDaGiornalieri').value;

    if (fromDate) {
      const maxPossible = {
        year: fromDate.year + 1,
        month: fromDate.month,
        day: fromDate.day
      };

      this.finalMaxDateGiornalieri = this.compareDates(maxPossible, this.maxSelectableDate) > 0
        ? this.maxSelectableDate
        : maxPossible;
      const toDate = this.dataForm.get('dataAGiornalieri')?.value;

      if (toDate) {
        if (
          this.compareDates(toDate, fromDate) < 0 ||
          this.compareDates(toDate, this.finalMaxDateGiornalieri) > 0
        ) {
          this.dataForm.get('dataAGiornalieri')?.setValue(null);
        }
      }
    } else {
      this.finalMaxDateGiornalieri = null;
      this.dataForm.get('dataAGiornalieri')?.setValue(null);
    }
  }

  fromObjectToReadableDate(obj: any): string {
    if (
      !obj ||
      typeof obj !== 'object' ||
      typeof obj.year !== 'number' ||
      typeof obj.month !== 'number' ||
      typeof obj.day !== 'number'
    ) {
      return "-";
    }

    // Formatta il giorno e il mese con due cifre
    const day = obj.day.toString().padStart(2, '0');
    const month = obj.month.toString().padStart(2, '0');

    return `${day}/${month}/${obj.year}`;
  };

  updateValidators(tipo: number) {

    const nome = this.dataForm.get('nome');
    const cognome = this.dataForm.get('cognome');
    const ente = this.dataForm.get('ente');

    if (tipo === 1) {
      nome?.setValidators([Validators.required]);
      cognome?.setValidators([Validators.required]);
      ente?.clearValidators();
    } else if (tipo === 2) {
      nome?.clearValidators();
      cognome?.clearValidators();
      ente?.setValidators([Validators.required]);
    } else {
      nome?.clearValidators();
      cognome?.clearValidators();
      ente?.clearValidators();
    }

    // Aggiorna la validazione per applicare le modifiche
    nome?.updateValueAndValidity();
    cognome?.updateValueAndValidity();
    ente?.updateValueAndValidity();
  };

  titleCase(str) {
    var splitStr = str.toLowerCase().split(' ');
    for (var i = 0; i < splitStr.length; i++) {
      // You do not need to check if i is larger than splitStr length, as your for does that for you
      // Assign it back to the array
      splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
    }
    // Directly return the joined string
    return splitStr.join(' ');
  };

  //tabella

  visualizzaTabella() {

  };

  caricaStazioniTabella(): void {
    this.restService.selectAllStazioniByFilters().then((
      data) => {
      if (data && data.listaStazioni) {
        // this.dataTabella = data.listaStazioni.sort((a: any, b: any) =>
        //   a.denominazione.localeCompare(b.denominazione)
        // );
        // Mantiene l'ordine originale dal servizio REST
        this.dataTabella = data.listaStazioni;

      } else {
        console.error('Nessuna stazione trovata.');
      }
    })
      .catch((err) => {
        console.error('Errore nel caricamento delle stazioni:', err);
      });
  };

  // ✅ 1. AGGIUNGI QUESTE VARIABILI IN CIMA ALLA CLASSE (dopo le altre variabili)

  pageSizeOptions = [10, 25, 50, 100, 200];
  currentPageSize = 25; // Default
  
  // ✅ Variabili per la tabella di consultazione nella modale
  pageSizeOptionsConsultazione = [10, 25, 50, 100, 200, 'Tutto'];
  currentPageSizeConsultazione = 25; // Default

  // ✅ 2. SOSTITUISCI IL METODO setupAgSettings() CON QUESTO:

  setupAgSettings() {
    let ref = this;

    ref.gridOptions = {
      // ✅ CONFIGURAZIONE PAGINAZIONE COMPLETA
      animateRows: true,
      pagination: true,
      paginationPageSize: this.currentPageSize,
      paginationPageSizeSelector: this.pageSizeOptions,
      paginationAutoPageSize: false,
      suppressPaginationPanel: false,

      onPaginationChanged: (event: any) => {
        const newPageSize = event.api.paginationGetPageSize();
        if (newPageSize !== this.currentPageSize) {
          this.currentPageSize = newPageSize;
          
        }
      },

      enableCellTextSelection: true,
      rowHeight: 50,
      suppressMovableColumns: true,
      rowSelection: 'single',
      suppressRowClickSelection: false,
      onRowClicked: (event: any) => {
        if (event.data) {
         this.idStazioneSelect = event.data.idStazione;
          this.onStationFilterChange();
        }
      },
      defaultColDef: {
        editable: false,
        filter: true,
        sortable: true,
        flex: 1,
        minWidth: 100,
        cellStyle: { display: 'flex', alignItems: 'center', justifyContent: 'center' },
        cellClass: 'fontClamp',
        headerClass: 'header-center',
        suppressMenu: true,
        floatingFilterComponentParams: {
          suppressFilterButton: true,
        },
        filterParams: {
          suppressAndOrCondition: true,
        },
      },
      rowStyle: {
        background: '#fff',
        color: '#000'
      },

      // ✅ TESTI LOCALIZZATI COMPLETI
      localeText: {
        // Paginazione
        page: 'Pagina',
        of: 'di',
        to: 'a',
        more: 'Altri',
        next: 'Successiva',
        last: 'Ultima',
        first: 'Prima',
        previous: 'Precedente',

        // Page size selector
        pageSize: 'Dimensione pagina',
        pageSizeSelectorLabel: 'Righe per pagina:',

        // Generali
        loadingOoo: 'Caricamento...',
        noRowsToShow: 'Nessun dato disponibile',

        // Filtri
        contains: 'Contiene',
        notContains: 'Non contiene',
        equals: 'Uguale a',
        notEqual: 'Diverso da',
        startsWith: 'Inizia con',
        endsWith: 'Finisce con',

        // Generale
        filterOoo: 'Filtra...',
        applyFilter: 'Applica filtro',
        resetFilter: 'Reset filtro',
        clearFilter: 'Pulisci filtro'
      },

      columnDefs: [
        {
          headerName: "Denominazione",
          field: "denominazione",
          wrapText: true,
          autoHeight: true,
          width: 250,
          cellStyle: {
            'white-space': 'normal',
            'text-align': 'center',
            'line-height': '1.4',
            'padding': '8px',
            'word-break': 'keep-all',
            'overflow-wrap': 'break-word',
            'hyphens': 'auto'
          },
          filter: "agTextColumnFilter",
          floatingFilter: true,
          valueFormatter: (params: any) => params.value ? params.value : "-"
        },
        {
          headerName: "Latitudine",
          field: "latitudine",
          cellClass: 'wrap-text tabella1',
          cellStyle: {
            'text-align': 'center'
          },
          filter: "agTextColumnFilter",
          floatingFilter: true,
          valueFormatter: (params: any) => params.value ? params.value : "-"
        },
        {
          headerName: "Longitudine",
          field: "longitudine",
          cellClass: 'wrap-text tabella1',
          cellStyle: {
            'text-align': 'center'
          },
          filter: "agTextColumnFilter",
          floatingFilter: true,
          valueFormatter: (params: any) => params.value ? params.value : "-"
        },
        {
          headerName: "Comune",
          field: "comune",
          wrapText: true,
          autoHeight: true,
          width: 250,
          cellStyle: {
            'white-space': 'normal',
            'text-align': 'center',
            'line-height': '1.4',
            'padding': '8px',
            'word-break': 'keep-all',
            'overflow-wrap': 'break-word',
            'hyphens': 'auto'
          },
          filter: "agTextColumnFilter",
          floatingFilter: true,
          valueFormatter: (params: any) => params.value ? params.value : "-"
        },
        {
          headerName: "Provincia",
          field: "provincia",
          cellClass: 'wrap-text tabella1',
          cellStyle: {
            'text-align': 'center'
          },
          filter: "agTextColumnFilter",
          floatingFilter: true,
          valueFormatter: (params: any) => params.value ? params.value : "-"
        },
        {
          headerName: "Regione",
          field: "regione",
          cellClass: 'wrap-text tabella1',
          cellStyle: {
            'text-align': 'center'
          },
          filter: "agTextColumnFilter",
          floatingFilter: true,
          valueFormatter: (params: any) => params.value ? params.value : "-"
        },
        {
          headerName: "Quota",
          field: "quota",
          cellClass: 'wrap-text tabella1',
          cellStyle: {
            'text-align': 'center'
          },
          filter: "agTextColumnFilter",
          floatingFilter: true,
          valueFormatter: (params: any) => params.value !== null ? params.value : "-"
        },
        {
          headerName: "Bacino",
          field: "bacino",
          cellClass: 'wrap-text tabella1',
          cellStyle: {
            'text-align': 'center'
          },
          filter: "agTextColumnFilter",
          floatingFilter: true,
          valueFormatter: (params: any) => params.value ? params.value : "-"
        },
        {
          headerName: "Azioni",
          field: "buttons",
          cellRenderer: MultiButtonRendererComponent,
          filter: false,
          sortable: false,
          cellRendererParams: {
            value: [
              {
                label: 'Vedi Sensori',
                class: 'clamp-icon icon now-ui-icons ui-1_zoom-bold btn btn-primary pointer',
                action: (row: any) => {
                  this.stazioneSelezionata = row
                  this.findSensoriFromTabella(row.idStazione)
                }
              }
            ]
          }
        }
      ]
    }
  }

  // ✅ 3. SOSTITUISCI IL METODO setupAgSettingsSensori() CON QUESTO:

  setupAgSettingsSensori() {
    let ref = this;

    ref.gridOptionsSensori = {
      animateRows: true,

      // ✅ CONFIGURAZIONE PAGINAZIONE COMPLETA PER SENSORI
      pagination: true,
      paginationPageSize: 10,
      paginationPageSizeSelector: [5, 10, 25, 50],
      paginationAutoPageSize: false,
      suppressPaginationPanel: false,

      enableCellTextSelection: true,
      rowHeight: 50,
      suppressMovableColumns: true,
      defaultColDef: {
        editable: false,
        filter: false,
        sortable: true,
        flex: 1,
        minWidth: 100,
        cellStyle: { display: 'flex', alignItems: 'center', justifyContent: 'center' },
        cellClass: 'wrap-text',
        
      },
      rowStyle: {
        background: '#fff',
        color: '#000'
      },

      // ✅ LOCALE TEXT COMPLETO
      localeText: {
        page: 'Pagina',
        of: 'di',
        to: 'a',
        more: 'Altri',
        next: 'Successiva',
        last: 'Ultima',
        first: 'Prima',
        previous: 'Precedente',
        loadingOoo: 'Caricamento...',
        noRowsToShow: 'Nessun dato disponibile'
      },

      columnDefs: [
        {
          headerName: "Denominazione",
          field: "nome",
          cellClass: 'wrap-text tabella1',
          filter: "agTextColumnFilter",
          floatingFilter: true,
          valueFormatter: (params: any) => params.value ? params.value : "-"
        },
        {
          headerName: "Tipo Sensore",
          field: "tipoSensore",
          filter: "agTextColumnFilter",
          floatingFilter: true,
          valueFormatter: (params: any) => params.value ? this.getFriendlyName(params.value) : "-"
        },
        /* {
          headerName: "Valore Massimo",
          field: "valoreMassimo",
          filter: "agTextColumnFilter",
          floatingFilter: true,
          valueFormatter: (params: any) => params.value ? params.value : "-"
        }, */
        {
          headerName: "Azioni",
          field: "buttons",
          cellRenderer: MultiButtonRendererComponent,
          filter: false,
          sortable: false,
          cellRendererParams: {
            value: [
              {
                label: 'Vedi Sensori',
                class: 'clamp-icon icon now-ui-icons ui-1_zoom-bold btn btn-primary pointer',
                action: (row: any) => {
                  this.openSensorDownload(row)
                }
              }
            ]
          }
        }
      ]
    }
  }

  // ✅ 4. AGGIUNGI QUESTI METODI HELPER:

  // Metodo per cambiare programmaticamente il page size
  changePageSize(newSize: number): void {
    this.currentPageSize = newSize;

    if (this.gridOptions?.api) {
      this.gridOptions.api.paginationSetPageSize(newSize);

      // Forza refresh
      setTimeout(() => {
        this.gridOptions.api.refreshCells();
      }, 100);
    } else {
     }
  }

  // ✅ Metodo per cambiare il page size nella tabella di consultazione
  changePageSizeConsultazione(newSize: number | string): void {
    if (newSize === 'Tutto') {
      // Disabilita la paginazione per mostrare tutti i dati
      this.currentPageSizeConsultazione = 999999; // Numero molto grande
      if (this.gridOptionsConsultazione?.api) {
        this.gridOptionsConsultazione.api.paginationSetPageSize(999999);
      }
    } else {
      // Abilita la paginazione con la dimensione specificata
      this.currentPageSizeConsultazione = newSize as number;
      if (this.gridOptionsConsultazione?.api) {
        this.gridOptionsConsultazione.api.paginationSetPageSize(newSize as number);
      }
    }

    // Forza refresh
    setTimeout(() => {
      if (this.gridOptionsConsultazione?.api) {
        this.gridOptionsConsultazione.api.refreshCells();
      }
    }, 100);
  }

  // Metodo per refresh della tabella
  refreshTable(): void {
    if (this.gridOptions?.api) {
      this.gridOptions.api.refreshCells();
      this.gridOptions.api.sizeColumnsToFit();
    }
  }

  findSensoriFromTabella(stationId) {
    this.restService.listAllSensoriByIdStazione(stationId, "*").then((data) => {
      if (data && data != null) {
        // CORREGGI: usa 'nome' invece di 'denominazione'
        // this.sensoriToDettaglioTabella = data.sort((a: any, b: any) => {
        //   const nomeA = a.nome || '';
        //   const nomeB = b.nome || '';
        //   return nomeA.localeCompare(nomeB);
        // });
        // Mantiene l'ordine originale dal servizio REST
        this.sensoriToDettaglioTabella = data;
        this.modalService.open(this.theModalSensori, { backdrop: 'static', windowClass: "modalDettaglioTabella" });
      } else {
      }
    })
      .catch((err) => {
      });
  }

  openPdfDocument(): void {
    const pdfUrlWithParams = `${this.pdfDocumentUrl}#&navpanes=0&scrollbar=0&view=FitH`;
    window.open(pdfUrlWithParams, 'PDF', 'left=20,top=20,width=800,height=700,resizable=1');
  }

  downloadExcelFile(): void {
    // Crea un link temporaneo per il download
    const link = document.createElement('a');
    link.href = this.excelDocumentUrl;
    link.download = 'TABELLA_STAZIONI.xlsx';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  // Metodi per gestire la disabilitazione temporanea dei pulsanti
  private disableButtons(): void {
    this.isButtonDisabled = true;
    this.clearButtonDisableTimer();
    this.buttonDisableTimer = setTimeout(() => {
      this.isButtonDisabled = false;
    }, this.buttonDisableTimeout);
  }

  private clearButtonDisableTimer(): void {
    if (this.buttonDisableTimer) {
      clearTimeout(this.buttonDisableTimer);
      this.buttonDisableTimer = null;
    }
  }

  private canExecuteRequest(): boolean {
    if (this.isButtonDisabled) {
      this.newModal.open(
        "Attenzione",
        `Attendere ${this.buttonDisableTimeout / 1000} secondi prima di effettuare una nuova richiesta.`,
        "bg-warning"
      );
      return false;
    }
    return true;
  }

  // Metodi per la consultazione intelligente
  private areParamsEqual(params1: any, params2: any): boolean {
    return params1.from?.year === params2.from?.year &&
           params1.from?.month === params2.from?.month &&
           params1.from?.day === params2.from?.day &&
           params1.to?.year === params2.to?.year &&
           params1.to?.month === params2.to?.month &&
           params1.to?.day === params2.to?.day &&
           params1.idSensore === params2.idSensore;
  }

  private resetConsultaState(): void {
    this.isConsultaDisabled = false;
    this.lastConsultaParams = null;
  }

}
